import "./CustomSlider.css";
import Icons from "../../Constants/Icons";


const CustomSlider = () => {



  return (
    <div className="slider-container">
      <div className=" ">
        <video
          className="hero-images"
          src={Icons.Ic_finance}
          autoPlay
          muted
          loop
          playsInline
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        ></video>
        <div className="hero-overlay"></div>

        <div className="slider-center-section">
          <div className="caption">
            <h2
              className="caption-text"
            >
              Khoury Private Office
            </h2>
            <div className="logo">Khoury Capital</div>
            <h3 className="hero-tagline">
              Trusted Access. Strategic Execution. Global Influence.
            </h3>
            <p
            >
              Khoury Private Office facilitates high-value transactions across
              energy, capital, technology, hospitality, and strategic
              investments.
            </p>

          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomSlider;
